import { Injectable } from '@angular/core';
import { Nillable } from '@core/utils/nil/nillable';

@Injectable({
  providedIn: 'root',
})
export class LocalRepositoryService {
  private readonly _localStorage = localStorage;

  setItem(key: string, value: string): void {
    this._localStorage.setItem(key, value);
  }

  getItem(key: string): Nillable<string> {
    return this._localStorage.getItem(key);
  }

  removeItem(key: string): void {
    this._localStorage.removeItem(key);
  }

  exists(key: string): boolean {
    try {
      return !!this.getItem(key);
    } catch (error) {
      return false;
    }
  }
}
